import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Nav,
  Container,
  Button,
  Form,
  InputGroup,
} from "react-bootstrap";
import DetailLayout from "../../../../components/DetailLayout";
import RedeemModal from "../../../../components/RedeemModal";
import {
  RedeemDialog,
  SelectAddressDialog,
} from "../../../../components/DialogCollection";
import * as Assets from "../../../../utils/svg_assets";
import * as PageRoutes from "../../../../utils/route_pages";
import { dateFormater, dateFormaterTime } from "../../../../utils/utilities";
import "./style.scss";
import parse from "html-react-parser";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { QrReader } from "react-qr-reader";
import ShowGoogleMap from "../../../../components/ShowGoogleMap";

const VoucherDetail = (props) => {
  const {
    reward_vouchers_detail,
    getRewardDetails,
    redemptionVoucher,
    profile,
  } = props;

  let { url_category, voucherId } = useParams();
  const [openRedeemModal, setOpenRedeemModal] = useState(false);
  const [openRedeemDialog, setOpenRedeemDialog] = useState(false);
  const [openAddressDialog, setOpenAddressDialog] = useState(false);
  const [resultData, setResultData] = useState({});
  const [referenceData, setReferenceData] = useState("");
  const [showPassNumber, setShowPassNumber] = useState("password");
  const [dataAddress, setDataAddress] = useState("");
  const [indexAddress, setIndexAddress] = useState(0);
  const [locationStore, setLocationStore] = useState("");
  const [showScan, setShowScan] = useState(false);
  const [activeTabs, setActiveTabs] = useState("howtouse");
  const [passCode, setPasCode] = useState("");
  const [refCamera, setRefCamera] = useState("environment");
  const [redeemedOn, setRedeemedOn] = useState("");

  const cust_email = profile.user_details.email;
  const cust_phone = profile.user_details.phone_number;

  const onChangeTabs = (tabActive) => {
    setActiveTabs(tabActive);
  };

  useEffect(() => {
    getRewardDetails({ id: voucherId });
  }, []);

  useEffect(() => {
    if (reward_vouchers_detail.locations.length > 0) {
      setDataAddress(reward_vouchers_detail.locations[0].address);
      setLocationStore(
        `${reward_vouchers_detail.locations[0].name}/${reward_vouchers_detail.locations[0].coordinates[0]},${reward_vouchers_detail.locations[0].coordinates[1]}`
      );
    }
  }, [reward_vouchers_detail]);

  useEffect(() => {
    if (passCode) {
      setShowScan(false);
      setOpenRedeemModal(true);
    }
  }, [passCode]);

  useEffect(() => {
    if (reward_vouchers_detail.locations.length > 0) {
      setDataAddress(reward_vouchers_detail.locations[indexAddress].address);
      setLocationStore(
        `${reward_vouchers_detail.locations[indexAddress].name}/${reward_vouchers_detail.locations[indexAddress].coordinates[0]},${reward_vouchers_detail.locations[indexAddress].coordinates[1]}`
      );
      setOpenAddressDialog(false);
    }
  }, [indexAddress]);

  const redeemProcess = async () => {
    let dataPayload;

    switch (reward_vouchers_detail.redemption_type) {
      case "flash_password":
        dataPayload = {
          reward: voucherId,
          user_data: {
            password: passCode,
            email: cust_email,
          },
        };
        break;
      case "flash":
        dataPayload = {
          reward: voucherId,
          user_data: {
            email: cust_email,
          },
        };
        break;
      case "e_voucher":
        dataPayload = {
          reward: voucherId,
          user_data: {
            phone: cust_phone,
            email: cust_email,
          },
        };
        break;
      case "voucher_topup":
        dataPayload = {
          reward: voucherId,
          user_data: {},
        };
        break;
      case "new_evoucher":
        dataPayload = {
          reward: voucherId,
          user_data: {
            email: cust_email,
          },
        };
        break;
      case "prezent":
        dataPayload = {
          reward: voucherId,
          user_data: {
            phone: cust_phone ? cust_phone : "null",
            email: cust_email,
          },
        };
        break;
      case "aldmic_voucher":
        dataPayload = {
          reward: voucherId,
          user_data: {
            email:
              profile?.organization_username_field == 1
                ? cust_email
                : cust_phone,
          },
        };
        break;
      default:
        dataPayload = {
          reward: voucherId,
          user_data: {
            phone: cust_phone,
            email: cust_email,
          },
        };
        break;
    }

    await redemptionVoucher(dataPayload).then((result) => {
      setResultData(result);
      setRedeemedOn(new Date());
      setReferenceData(result.responseFull.reference);
      setOpenRedeemModal(false);
      setOpenRedeemDialog(true);
    });
  };

  const handleRefCamera = () => {
    setRefCamera(refCamera === "environment" ? "user" : "environment");
  };

  const HeaderScan = (props) => {
    const innerStyle = {
      borderBottom: "1px solid #ebebeb",
    };

    return (
      <div
        className="scan-navigation"
        style={props.setBorder ? innerStyle : { boxShadow: "none" }}
      >
        <div
          className="left-navigation"
          onClick={() => {
            setShowScan(false);
            setOpenRedeemModal(true);
          }}
        >
          {props.showLeftIcon && (
            <img
              src={props.iconLeft}
              className="icon-left-scan"
              alt="arrow-back"
            />
          )}
        </div>
        <div className="title-page">{props.titlePage}</div>
        <div className="right-navigation" onClick={handleRefCamera}>
          {props.showRightIcon && (
            <img
              src={props.iconRight}
              className="icon-right-scan"
              alt="filter"
            />
          )}
        </div>
      </div>
    );
  };

  const ReaderScan = () => {
    const innerStyle = {
      textAlign: "center",
      margin: "auto",
      maxWidth: 400,
      width: "75%",
    };

    return (
      <div style={innerStyle}>
        <QrReader
          delay={500}
          onResult={(result, error) => {
            if (result) {
              setPasCode(result?.text);
            }
            if (error) {
              console.log("error:", error);
            }
          }}
          style={{ width: "100%" }}
          constraints={{ facingMode: refCamera }}
        />
      </div>
    );
  };

  return (
    <DetailLayout
      headerImg={reward_vouchers_detail.display_img_url}
      referenceData={referenceData}
      backPage={PageRoutes.discountVoucher + `/${url_category}`}
    >
      <Container>
        <div className="detail-name">{reward_vouchers_detail.name}</div>
        <div
          className="detail-description"
          dangerouslySetInnerHTML={{
            __html: reward_vouchers_detail.description,
          }}
        />
        <div className="detail-valid">
          {reward_vouchers_detail.valid_until
            ? `Valid Until ${dateFormater(reward_vouchers_detail.valid_until)}`
            : ""}
        </div>
        {redeemedOn && (
          <div className="detail-redeemedon">{`Redeemed On ${dateFormaterTime(
            redeemedOn
          )}`}</div>
        )}
        {reward_vouchers_detail.locations.length > 0 ? (
          <div className="detail-address">
            <Row>
              <Col className="address-label">Address</Col>
            </Row>
            <Row className="address-info">
              <Col xs={8} sm={8} md={8}>
                <div>{dataAddress}</div>
              </Col>
              <Col xs={4} sm={4} md={4}>
                <Button variant="danger" className="btn-direction">
                  <Row>
                    <Col xs={3} sm={3} md={3}>
                      <img
                        src={Assets.iconDirection}
                        className="icon-direction"
                        alt="icon-email"
                      />
                    </Col>
                    <Col xs={9} sm={9} md={9}>
                      <a
                        className="direct-map"
                        href={`http://www.google.com/maps/place/${locationStore}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Direction
                      </a>
                    </Col>
                  </Row>
                </Button>
              </Col>
            </Row>
            <Row
              className="address-all"
              onClick={() => {
                setOpenAddressDialog(true);
              }}
            >
              {reward_vouchers_detail.locations.length > 1
                ? "See all store address"
                : ""}
            </Row>
          </div>
        ) : (
          ""
        )}
        <div className="detail-contact">
          <Row>
            <Col className="contact-label">Contact</Col>
          </Row>
          <Row className="contact-email">
            <Col xs={1} sm={1} md={1}>
              <img
                src={Assets.iconEmail}
                className="icon-email"
                alt="icon-email"
              />
            </Col>
            <Col>{reward_vouchers_detail.contact_details.email}</Col>
          </Row>
          <Row className="contact-phone">
            <Col xs={1} sm={1} md={1}>
              <img
                src={Assets.iconSupportCall}
                className="icon-phone"
                alt="icon-phone"
              />
            </Col>
            <Col>{reward_vouchers_detail.contact_details.phone}</Col>
          </Row>
          <Row className="contact-website">
            <Col xs={1} sm={1} md={1}>
              <img
                src={Assets.iconTopup}
                className="icon-website"
                alt="icon-website"
              />
            </Col>
            <Col>{reward_vouchers_detail.merchant.website}</Col>
          </Row>
        </div>
        {referenceData && (
          <div className="discount-map">
            {reward_vouchers_detail.locations.length > 0 ? (
              <ShowGoogleMap
                listMarker={[
                  {
                    name: reward_vouchers_detail.locations[indexAddress].name,
                    address:
                      reward_vouchers_detail.locations[indexAddress].address,
                    position: {
                      lat: reward_vouchers_detail.locations[indexAddress]
                        .coordinates[1],
                      lng: reward_vouchers_detail.locations[indexAddress]
                        .coordinates[0],
                    },
                  },
                ]}
                dataCenter={{
                  lat: reward_vouchers_detail.locations[indexAddress]
                    .coordinates[1],
                  lng: reward_vouchers_detail.locations[indexAddress]
                    .coordinates[0],
                }}
              />
            ) : (
              ""
            )}
          </div>
        )}
        {!referenceData && (
          <div className="detail-tab">
            <Row>
              <Nav
                className="justify-content-center"
                variant="pills"
                defaultActiveKey={activeTabs}
              >
                <Nav.Item>
                  <Nav.Link
                    eventKey="howtouse"
                    onClick={() => onChangeTabs("howtouse")}
                  >
                    How to use
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="overview"
                    onClick={() => onChangeTabs("overview")}
                  >
                    Overview
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="moreinfo"
                    onClick={() => onChangeTabs("moreinfo")}
                  >
                    More Info
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Row>
            {activeTabs === "howtouse" && (
              <Row className="detail-tab-info">
                <div className="detail-howtouse">
                  {parse(
                    reward_vouchers_detail.how_to_use
                      ? reward_vouchers_detail.how_to_use
                      : ""
                  )}
                </div>
              </Row>
            )}
            {activeTabs === "overview" && (
              <Row className="detail-tab-info">
                <div className="detail-howtouse">
                  {parse(
                    reward_vouchers_detail.merchant.description
                      ? reward_vouchers_detail.merchant.description
                      : ""
                  )}
                </div>
              </Row>
            )}
            {activeTabs === "moreinfo" && (
              <Row className="detail-tab-info">
                <div className="detail-howtouse">
                  {parse(
                    reward_vouchers_detail.more_info
                      ? reward_vouchers_detail.more_info
                      : ""
                  )}
                </div>
              </Row>
            )}
          </div>
        )}
        <div className="detail-button">
          <Button
            variant="danger"
            className="btn-detail-redeem"
            disabled={
              referenceData || !reward_vouchers_detail.redeemable ? true : false
            }
            onClick={() => {
              setOpenRedeemModal(true);
            }}
          >
            {referenceData ? "Redeemed" : "Redeem"}
          </Button>
        </div>
      </Container>
      <RedeemModal
        redeemtioType={reward_vouchers_detail.redemption_type}
        redeemptionImage={reward_vouchers_detail.thumbnail_img_url}
        redeemptionName={reward_vouchers_detail.name}
        redeemptionDescription={reward_vouchers_detail.description}
        redeemptionTitle={reward_vouchers_detail.merchant.name}
        redeemptionPoint={reward_vouchers_detail.points_label}
        show={openRedeemModal}
      >
        {reward_vouchers_detail.redemption_type === "flash_password" && (
          <Form.Group as={Col} className="input-password-number">
            <InputGroup className="mb-3 password">
              <img
                src={
                  showPassNumber === "password"
                    ? Assets.iconEye
                    : Assets.iconEyeActive
                }
                onClick={() => {
                  setShowPassNumber(
                    showPassNumber === "password" ? "text" : "password"
                  );
                }}
                className="pln-img"
                alt="pln_image"
              />
              <Form.Control
                variant="danger"
                type={showPassNumber}
                placeholder="Enter Passcode"
                value={passCode}
                onChange={(e) => {
                  setPasCode(e.target.value);
                }}
              />
              <img
                src={Assets.iconQrScan}
                onClick={() => {
                  setOpenRedeemModal(false);
                  setShowScan(true);
                }}
                className="qrscan-img"
                alt="qrscan_image"
              />
            </InputGroup>
          </Form.Group>
        )}

        <div className="d-grid gap-2">
          <Button variant="danger" onClick={() => redeemProcess()}>
            Redeem
          </Button>
          <Button
            variant="outline-danger"
            onClick={() => {
              setOpenRedeemModal(false);
            }}
          >
            Cancel
          </Button>
        </div>
      </RedeemModal>
      <RedeemDialog
        title={resultData.status === 200 ? "Successful" : "Unsuccessful"}
        iconRedeem={reward_vouchers_detail.thumbnail_img_url}
        voucherRedeemName={reward_vouchers_detail.name}
        voucherRedeemDescription={reward_vouchers_detail.description}
        message={resultData.message}
        redeemptionType={reward_vouchers_detail.redemption_type}
        showDescription={
          reward_vouchers_detail.redemption_type === "e_voucher" ? false : true
        }
        show={openRedeemDialog}
        onHide={() => {
          setOpenRedeemDialog(false);
        }}
      />
      <SelectAddressDialog
        title="Select Store Location"
        listAddress={reward_vouchers_detail.locations}
        show={openAddressDialog}
        onHide={() => {
          setOpenAddressDialog(false);
        }}
        setIndexAddress={setIndexAddress}
        indexAddress={indexAddress}
      />
      <Drawer
        open={showScan}
        onClose={() => setShowScan(false)}
        direction="right"
        size={400}
        enableOverlay={false}
        overlayColor={"#ffffff"}
      >
        <HeaderScan
          titlePage="Scan QR Code"
          setBorder={true}
          showRightIcon={true}
          showLeftIcon={true}
          iconLeft={Assets.iconBack}
          iconRight={
            refCamera === "environment" ? Assets.iconEye : Assets.iconEyeActive
          }
          onRightNavClicked={handleRefCamera}
        />
        {showScan && <ReaderScan />}
      </Drawer>
    </DetailLayout>
  );
};

const mapStateToProps = (state) => ({
  reward_vouchers_detail: state.RewardSM.reward_vouchers_detail,
  profile: state.LoginSM.login,
  pointSummaryData: state.FinanceSM.pointSummaryData,
});

const mapDispatchToProps = (dispatch) => ({
  getRewardDetails: dispatch.RewardSM.getRewardDetails,
  redemptionVoucher: dispatch.RedeemSM.redemptionVoucher,
  setFinanceState: dispatch.FinanceSM.setFinanceState,
  setLoginData: dispatch.LoginSM.setLoginData,
});

export default connect(mapStateToProps, mapDispatchToProps)(VoucherDetail);
